// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datepicker-options[data-v-b5a85868]{display:none}.vs-form-datepicker[data-v-b5a85868]:focus{box-shadow:none}.grid-cols-7[data-v-b5a85868]{grid-template-columns:repeat(7,minmax(0,1fr))}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
